import { render, staticRenderFns } from "./GerPerguntas.vue?vue&type=template&id=1174a402&"
import script from "./GerPerguntas.vue?vue&type=script&lang=js&"
export * from "./GerPerguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports